import React from "react";
import FoundingLeadModal from "@/components/marketing/FoundingLeadModal";
import { useVipModalListener } from "@/lib/vipModal";

/**
 * Mount once near the App root. Listens for `openVipModal(tier, source)` calls
 * from anywhere in the tree and renders the lead-capture modal.
 */
export default function GlobalVipModal() {
  const { open, tier, source, close } = useVipModalListener();
  return (
    <FoundingLeadModal
      open={open}
      onClose={close}
      tier={tier}
      source={source}
    />
  );
}
